export default __webpack_public_path__ + "static/media/hero_back_1.9b02616a.png";